import { render, staticRenderFns } from "./UjianProcessSimbolAritmatika.vue?vue&type=template&id=5a2e65c5&scoped=true"
import script from "./UjianProcessSimbolAritmatika.vue?vue&type=script&lang=js"
export * from "./UjianProcessSimbolAritmatika.vue?vue&type=script&lang=js"
import style0 from "./UjianProcessSimbolAritmatika.vue?vue&type=style&index=0&id=5a2e65c5&prod&scoped=true&lang=css"
import style1 from "./UjianProcessSimbolAritmatika.vue?vue&type=style&index=1&id=5a2e65c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e65c5",
  null
  
)

export default component.exports